import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTimes } from "@fortawesome/free-solid-svg-icons"

const ReportDrawer = ({ isOpen, onClose, logData }) => {
  const getReportText = () => {
    if (logData?.illustration_logs?.length > 0) {
      return (
        logData.illustration_logs[0].ExtractedReportText ||
        "No report text available"
      )
    }
    return "No report text available"
  }

  const getPromptsWithViewType = () => {
    if (!logData?.illustration_logs?.length) return []

    const seen = new Set()

    return logData.illustration_logs.reduce((prompts, result, index) => {
      const viewType = result.LogType || "N/A"
      if (seen.has(viewType)) return prompts
      seen.add(viewType)

      prompts.push({
        viewType,
        prompt: result.AIPrompt || "No prompt available",
        index,
      })

      return prompts
    }, [])
  }

  const prompts = getPromptsWithViewType()

  if (!isOpen) return null

  return (
    <>
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity"
        onClick={onClose}
      />

      <div className="fixed top-0 right-0 h-full w-2/3 bg-white shadow-xl z-50 transform transition-transform overflow-y-auto">
        <div className="sticky top-0 bg-white border-b border-gray-200 p-6 z-10">
          <div className="flex justify-between items-start">
            <div className="flex-1">
              <div className="text-xs text-gray-600 mb-2">
                {(logData.bodyPart || "N/A").toUpperCase()} -{" "}
                {logData.accessionNumber}
              </div>
              <div className="text-2xl font-bold text-gray-900 mb-4">
                {logData.accessionNumber}
              </div>
            </div>

            <button
              className="text-gray-400 hover:text-gray-600 transition-colors p-2"
              onClick={onClose}
            >
              <FontAwesomeIcon className="w-4 h-4" icon={faTimes} />
            </button>
          </div>
        </div>

        <div className="p-6">
          <div className="mb-8">
            <h3 className="text-sm font-semibold text-gray-700 mb-4 uppercase">
              Report Text
            </h3>
            <div className="bg-gray-100 rounded-lg p-4">
              <p className="text-sm text-gray-800 leading-relaxed whitespace-pre-wrap max-h-[300px] overflow-y-auto">
                {getReportText()}
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-gray-700 mb-4 uppercase">
              Prompts Used
            </h3>

            {prompts.length > 0 ? (
              <div className="space-y-4">
                {prompts.map((promptData, index) => (
                  <div
                    key={index}
                    className="border border-gray-200 rounded-lg"
                  >
                    <div className="bg-gray-100 px-4 py-3 border-b border-gray-200 rounded-t-lg">
                      <h4 className="font-medium text-gray-700">
                        {promptData.viewType.toUpperCase()}
                      </h4>
                    </div>

                    <div className="p-4 max-h-[300px] overflow-y-auto">
                      <p className="text-gray-700 text-sm leading-relaxed whitespace-pre-wrap">
                        {promptData.prompt}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-8 text-gray-500">
                No prompts available for this study
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default ReportDrawer
